import React, { useEffect, useState } from "react";
import {GSForm, GSRadioGroup, GSSidePanelPage} from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useMatch, useNavigate } from "react-router-dom";

//import scss
import "./tournament-team-remove-player.scss";
import { getRemoveTitle, removeItemForm } from "../../../forms/DeleteForm";
import TournamentTeamPlayerItem from "./tournament-team-player-item";
import { useSelector } from "react-redux";
import {
  clearNotifications, getTournamentRemovedPlayers,
  getTournamentTeam,
  getTournamentTeamPlayer, getTournamentUnassignedPlayers, removePlayerFromTeam,
  selectCurrentTeam,
  selectCurrentTeamPlayer,
  selectTeamsNotifications,
  setCurrentTempPlayer,
} from "../../../reducers/teamsSlice";
import { useDispatch } from "react-redux";
import {
  useNotificationAction,
  useNotificationBanner,
} from "../../../hooks/notificationHooks";
import {getTournament, selectCurrentTournament} from "../../../reducers/tournamentSlice";

//Name the component
const TournamentTeamRemovePlayer = (props) => {
  const [isValid, setIsValid] = useState(true);
  const [removalOption, setRemovalOption] = useState("unassign");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const currentTournament = useSelector(selectCurrentTournament);
  const currentTeam = useSelector(selectCurrentTeam);
  const currentPlayer = useSelector(selectCurrentTeamPlayer);
  const notifications = useSelector(selectTeamsNotifications);

  const matchRemove = useMatch(
    "/:tournamentID/teams/:teamID/edit/players/edit/:playerID/remove"
  );

  useEffect(() => {
    if (matchRemove?.params?.teamID && currentTeam?.id !== matchRemove?.params?.teamID) {
      dispatch(getTournamentTeam(matchRemove.params.teamID));
    }
  }, [dispatch, matchRemove?.params?.teamID, currentTeam?.id]);

  useEffect(() => {
    if (matchRemove?.params?.playerID && `${matchRemove.params.playerID}`.includes("-")) {
      dispatch(getTournamentTeamPlayer(matchRemove.params.playerID));
    } else {
      dispatch(setCurrentTempPlayer(matchRemove.params.playerID));
    }
    return () => {clearNotifications()};
  }, [dispatch, matchRemove?.params?.playerID]);

  useNotificationAction("removed", notifications, () => {
    //removing the last player disqualifies the team, which takes it out of the
    //tournament's registered count the round headers subtract from, the same
    //way deleting a team does
    dispatch(getTournament(matchRemove.params.tournamentID));
    dispatch(getTournamentUnassignedPlayers(matchRemove.params.tournamentID));
    dispatch(getTournamentRemovedPlayers(matchRemove.params.tournamentID));
    dispatch(clearNotifications());
    navigate(-2, {replace: true});
  });

  const removePlayer = () => {
    setIsValid(false);
    const context = {
      player: currentPlayer,
      team: currentTeam,
      isMainContact: currentPlayer?.mainContact || false,
      removalOption: removalOption,
    };

    dispatch(removePlayerFromTeam(context));
  }

  const getDrawerActions = () => {
    let actions = [
      {
        name: "Remove",
        isDisabled: !isValid,
        action: removePlayer,
        type: "red",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    return actions;
  };

  const leftNavigation = () => {
    navigate(-1);
  };

  const getNavigation = () => {
    //Add Title to your component
    return {
      title: `Remove Player`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const removalOptions = [
    { label: "Move to Unassigned Players list", value: "unassign" },
    { label: "Remove Player", value: "delete" },
  ];

  const getSelectedOption = () => {
    let option = removalOptions?.find?.(option => option.value === removalOption);
    return option ? option : removalOptions?.[0];
  };

  const getContent = () => {
    let formSections = removeItemForm(
      `${currentPlayer?.name}`,
      <TournamentTeamPlayerItem {...currentPlayer} player={currentPlayer} tournament={currentTournament} />,
      "remove",
      "What would you like to do with this player?"
    );
    formSections[0].fields.push({
      type: "vertical xx-large-gap",
      label: "Removal Options *",
      description: "Unassigned players can be added to teams.",
      value: (
        <GSRadioGroup
          options={removalOptions}
          selectedOption={getSelectedOption()}
          selectionChanged={(option) => setRemovalOption(option.value)}
        ></GSRadioGroup>
      ),
      customView: true,
    });

    return (
      <GSForm
        formTitle={getRemoveTitle("Remove Player")}
        formSections={formSections}
      ></GSForm>
    );
  };

  const getDrawer = () => {
    return {
      actions: getDrawerActions(),
    };
  };

  const [banner]  = useNotificationBanner({notifications})

  return (
    //name the component tag
    <tournament-team-remove-player>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
        drawer={getDrawer()}
      ></GSSidePanelPage>
    </tournament-team-remove-player>
  );
};

//export the new name
export default TournamentTeamRemovePlayer;
